import React, { useState } from "react";
import { IonButton, IonItem, IonCol, IonCheckbox } from "@ionic/react";
import { Bot } from "../types/bot.type";
import getCoinImage from "../utils/getCoinImage";
import { getCoinName } from "../utils/getCoinName";
import HelpButton from "./HelpButton";

interface QuoteAssetSelectorProps {
  bot: Bot;
  updateBot: (bot: Bot) => void;
}

const QuoteAssetSelector: React.FC<QuoteAssetSelectorProps> = ({
  bot,
  updateBot
}) => {
  const [editMode, setEditMode] = useState(false);
  const handleEditClick = () => {
    setEditMode(true);
  };
  const quoteAssets =
    bot?.mode === "live" ? ["USDT"] : ["USDT", "BTC", "ETH", "BNB"];

  const handleCancel = () => {
    setEditMode(false);
  };

  const handleSelect = (quoteAsset: string) => {
    const updatedBot = { ...bot, quoteAsset };
    updateBot(updatedBot);
    setEditMode(false);
  };

  return (
    <>
      <div className="mt-4 py-4 rounded-xl bg-primary-90 px-2">
        <div className="grid grid-cols-3 items-center px-2 gap-4">
          <p className="text-sm text-white col-span-2">Quote Asset</p>
          <div className="flex justify-end items-center col-span-1 -m-3">
            {!bot?.provisioned && (
              <>
                {editMode ? (
                  <IonButton size="small" fill="clear" onClick={handleCancel}>
                    Cancel
                  </IonButton>
                ) : (
                  bot?.mode !== "live" && (
                    <IonButton
                      size="small"
                      color="primary"
                      onClick={handleEditClick}
                    >
                      Edit
                    </IonButton>
                  )
                )}
              </>
            )}
            <HelpButton id="quote_asset" />
          </div>
        </div>

        {editMode ? (
          <>
            {quoteAssets.map(quoteAsset => (
              <IonItem
                key={quoteAsset}
                className="ion-no-padding pt-2"
                lines="none"
                button
                detail={false}
                onClick={() => handleSelect(quoteAsset)}
              >
                <div className="flex py-2 border-b border-primary-80 rounded ml-2 w-full">
                  <IonCol size="2" sizeLg="1" className="flex items-center">
                    <img
                      src={getCoinImage(quoteAsset)}
                      alt={quoteAsset}
                      className="mx-2 w-[32px] h-[32px]"
                    />
                  </IonCol>
                  <IonCol className="flex items-center">
                    {getCoinName(quoteAsset)} ({quoteAsset})
                  </IonCol>
                  <IonCol size="1" className="flex items-center">
                    <IonCheckbox
                      className="p-0 -m-1"
                      mode="md"
                      checked={bot?.quoteAsset === quoteAsset}
                    />
                  </IonCol>
                </div>
              </IonItem>
            ))}
          </>
        ) : (
          <IonItem className="ion-no-padding pt-2" lines="none">
            <div className="flex py-2  rounded ml-2 w-full">
              <IonCol size="2" sizeLg="1" className="flex items-center">
                <img
                  src={getCoinImage(bot.quoteAsset)}
                  alt={bot.quoteAsset}
                  className="mx-2 w-[32px] h-[32px]"
                />
              </IonCol>
              <IonCol className="flex items-center">
                {getCoinName(bot.quoteAsset)} ({bot.quoteAsset})
              </IonCol>
            </div>
          </IonItem>
        )}
      </div>
    </>
  );
};

export default QuoteAssetSelector;
